import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Play, Headphones, Mic, TrendingUp, Target, ArrowRight } from 'lucide-react';
import { podcasts, podcastCategories, PODCAST_API } from '../data/mockData';
import WhatsAppFloatingButton from "../pages/WhatsAppFloatingButton";
import { Oval } from 'react-loader-spinner';
function decodeHtml(text) {
  if (!text) return "";
  const el = document.createElement("textarea");
  el.innerHTML = text;
  return el.value;
}
const PodcastsPage = () => {
  const [podcasts, setPodcasts] = useState([]);

const [selectedPodcast, setSelectedPodcast] = useState(null);

const reversedPodcasts = [...podcasts].reverse();



  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1, delayChildren: 0.2 },
    },
  };


  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { type: 'spring', stiffness: 100, damping: 12 },
    },
  };

  const categoryIcons = [TrendingUp, Mic, Target, Headphones];
  const categoryColors = ['bg-light-blue', 'bg-ice-blue', 'bg-sage-light', 'bg-amber-light'];

  const [loading, setLoading] = useState(true);

   useEffect(() => {
    fetch(PODCAST_API)
      .then((res) => res.json())
      .then((data) => {
      const formatted = data.map((item) => {
  const videoId = item.url?.split("v=")[1]?.split("&")[0];
  return {
    id: Number(item.id),
    title: decodeHtml(item.Title),
    youtubeId: videoId
  };
});

setPodcasts(formatted);

        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, []);
  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="py-24 lg:py-32 bg-slate-blue relative overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://images.unsplash.com/photo-1478737270239-2f02b77fc618?w=1600&q=80" 
            alt="Podcast studio"
            className="w-full h-full object-cover opacity-20"
          />
        </div>
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 relative z-10">
          <motion.div
            initial="hidden"
            animate="visible"
            variants={containerVariants}
            className="grid lg:grid-cols-2 gap-12 items-center"
          >
            <div>
              <motion.span variants={itemVariants} className="service-tag bg-light-blue text-royal-blue">
                Mowgi Podcasts
              </motion.span>
              <motion.h1 variants={itemVariants} className="text-5xl md:text-6xl font-bold mt-6 mb-8 text-white">
                Videos & <span className="text-blue-300">Podcasts</span>
              </motion.h1>
              <motion.p variants={itemVariants} className="text-xl text-gray-300 leading-relaxed">
                Explore our collection of videos and podcasts, offering insights into all that moves markets – our discussions on asset management, wealth management, public markets, private markets and digital assets.
              </motion.p>
            </div>
            <motion.div variants={itemVariants} className="flex justify-center">
              <div className="w-56 h-56 md:w-72 md:h-72 rounded-full bg-white/10 flex items-center justify-center border border-white/20">
                <Play className="w-16 h-16 text-white" />
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Podcast Categories */}
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-100px' }}
            variants={containerVariants}
          >
            <motion.div variants={itemVariants} className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-navy">Podcast Series</h2>
            </motion.div>

            <motion.div variants={containerVariants} className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {podcastCategories.map((category, index) => {
                const [title, description] = category.split(' – ');
                const Icon = categoryIcons[index];
                const color = categoryColors[index];

                return (
                  <motion.div
                    key={index}
                    variants={itemVariants}
                    className={`${color} p-6 rounded-lg card-hover border border-gray-100`}
                  >
                    <Icon className="w-8 h-8 text-royal-blue mb-4" />
                    <h3 className="font-bold text-lg text-navy mb-2">{title}</h3>
                    <p className="text-steel-blue text-sm">{description}</p>
                  </motion.div>
                );
              })}
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Featured Video */}
      {selectedPodcast ? (
        <section className="py-16 bg-snow">
          <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="bg-navy rounded-lg overflow-hidden"
            >
              <div className="aspect-video">
                <iframe
                  src={`https://www.youtube.com/embed/${selectedPodcast.youtubeId}?autoplay=1`}
                  title={selectedPodcast.title}
                  className="w-full h-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
              <div className="p-6 text-white">
                <span className="service-tag bg-light-blue text-royal-blue mb-3">
                  {selectedPodcast.category}
                </span>
                <h3 className="text-2xl font-bold mb-2">{selectedPodcast.title}</h3>
                <p className="text-gray-400">{selectedPodcast.description}</p>
                <button
                  onClick={() => setSelectedPodcast(null)}
                  className="mt-4 text-sm text-gray-400 hover:text-white transition-colors"
                >
                  Close Player
                </button>
              </div>
            </motion.div>
          </div>
        </section>
      ) : null}
<WhatsAppFloatingButton />
      {/* All Podcasts Grid */}
      <section className="py-16 lg:py-24 bg-snow">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-100px' }}
            variants={containerVariants}
          >
            <motion.div variants={itemVariants} className="flex items-center justify-between mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-navy">Latest Episodes</h2>
            </motion.div>

            <motion.div variants={containerVariants} className="grid md:grid-cols-2 gap-8">
             {reversedPodcasts.map((podcast) => ( 
  <motion.div
    key={podcast.id}
    variants={itemVariants}
    className="bg-white rounded-lg overflow-hidden card-hover group cursor-pointer border border-gray-100"
  >
    {/* Direct YouTube Video */}
    <div className="aspect-video relative overflow-hidden">
      <iframe
        className="w-full h-full"
        src={`https://www.youtube.com/embed/${podcast.youtubeId}`}
        title={podcast.title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>

  
  </motion.div>
))}

            </motion.div>
          </motion.div>
        </div>
      </section>
<div>
    <div style={{
      display:"flex",
      justifyContent:"center",
      alignItems:"center",
      marginBottom:"20px"
    }}>
    {loading &&  <Oval
      height={80}
      width={80}
      color="#4fa94d"
      wrapperStyle={{}}
      wrapperClass=""
      visible={true}
      ariaLabel='oval-loading'
      secondaryColor="#4fa94d"
      strokeWidth={2}
      strokeWidthSecondary={2}
    />
}
</div>
    </div>
      {/* Humanize Brand Section */}
      <section className="py-24 lg:py-32 bg-light-blue">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-100px' }}
            variants={containerVariants}
            className="grid lg:grid-cols-2 gap-12 items-center"
          >
            <motion.div variants={itemVariants}>
              <span className="service-tag bg-royal-blue text-white">Podcast Services</span>
              <h2 className="text-4xl md:text-5xl font-bold mt-4 mb-6 text-navy">
                Humanise your brand
              </h2>
              <p className="text-steel-blue text-lg leading-relaxed mb-6">
                Mowgi enables you to humanise your brand by end-to-end crafting and implementing your podcasting journey! From conceptualisation to distribution, we handle everything.
              </p>
              <ul className="space-y-4">
                {[
                  'Conceptualisation & Strategy',
                  'Scripting & Speaker Preparation',
                  'Professional Filming & Editing',
                  'Marketing & Distribution',
                ].map((item, index) => (
                  <li key={index} className="flex items-center space-x-3 text-navy">
                    <div className="w-6 h-6 rounded-md bg-royal-blue flex items-center justify-center">
                      <span className="text-white text-xs font-bold">{index + 1}</span>
                    </div>
                    <span className="font-medium">{item}</span>
                  </li>
                ))}
              </ul>
            </motion.div>

            <motion.div variants={itemVariants} className="flex justify-center">
              <div className="grid grid-cols-2 gap-4">
                {[Mic, Headphones, Play, TrendingUp].map((Icon, index) => (
                  <div
                    key={index}
                    className="w-28 h-28 rounded-lg bg-white flex items-center justify-center shadow-sm"
                  >
                    <Icon className="w-10 h-10 text-royal-blue" />
                  </div>
                ))}
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 lg:py-32 bg-royal-blue">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-100px' }}
            variants={containerVariants}
            className="text-center"
          >
            <motion.h2 variants={itemVariants} className="text-4xl md:text-5xl font-bold text-white mb-6">
              Ready to Start Your Podcast Journey?
            </motion.h2>
            <motion.p variants={itemVariants} className="text-blue-100 text-lg max-w-2xl mx-auto mb-8">
              Let's discuss how we can help you create compelling content.
            </motion.p>
            <motion.div variants={itemVariants}>
              <Link to="/contact" className="cta-button !bg-white !text-royal-blue hover:!bg-gray-100">
                Let's Connect
              </Link>
            </motion.div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default PodcastsPage;
